var _path, _path2, _path3, _ellipse, _path4, _path5, _path6, _path7, _path8, _path9, _ellipse2, _path10, _path11, _path12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAzle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 474,
    height: 474,
    viewBox: "0 0 474 474",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82 405V103.002C94.0266 126.813 158.844 145 237 145C315.156 145 379.973 126.813 392 103.002V405C392 432.614 322.604 455 237 455C151.396 455 82 432.614 82 405Z",
    fill: "url(#paint0_linear_103_70)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237 213.5C185.732 248.5 108 246 106 213V392.037V392.544H106.014C107.06 411.068 165.304 426 237 426C308.696 426 366.94 411.068 367.986 392.544H368V392.061C368 392.053 368 392.045 368 392.037C368 392.029 368 392.021 368 392.014V206C335.458 165.93 274 188.241 237 213.5Z",
    fill: "url(#paint1_linear_103_70)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237 213.5C185.732 248.5 108 246 106 213V392.037V392.544H106.014C107.06 411.068 165.304 426 237 426C308.696 426 366.94 411.068 367.986 392.544H368V392.061C368 392.053 368 392.045 368 392.037C368 392.029 368 392.021 368 392.014V206C335.458 165.93 274 188.241 237 213.5Z",
    fill: "url(#paint2_linear_103_70)",
    fillOpacity: 0.2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 237,
    cy: 392.037,
    rx: 131,
    ry: 33.9631,
    fill: "url(#paint3_radial_103_70)",
    fillOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M237 213.5C237 213.5 204.5 238.478 158 239C128.002 239.337 105.5 230.5 106 211C106 192.499 134.507 185 153.5 185.5C191.5 186.5 237 213.5 237 213.5Z",
    fill: "url(#paint4_linear_103_70)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M237 213.5C237 213.5 269.5 233.478 316 234C345.998 234.337 368.5 225.5 368 206C368 206 353 184 320 184C277.5 184 237 213.5 237 213.5Z",
    fill: "url(#paint5_linear_103_70)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M224.366 381.399C224.142 380.655 217.96 360.083 217.736 359.339C206.598 358.853 195.48 357.941 184.414 356.602C182.193 363.596 179.962 370.573 177.72 377.523C170.787 376.564 163.878 375.436 157 374.137C167.826 345.727 178.52 316.382 189.087 286.982C196.981 287.823 204.897 288.455 212.823 288.877C223.756 320.251 234.433 350.908 245.358 381.491C238.361 381.63 231.361 381.599 224.366 381.399V381.399ZM213.113 342.812C212.429 340.575 207.162 323.329 206.478 321.092C206.061 319.642 205.496 317.785 204.785 315.519C204.115 313.214 203.424 310.886 202.711 308.533C202.041 306.142 201.494 304.072 201.074 302.325C200.661 304.004 200.081 306.089 199.336 308.574C198.631 311.022 197.948 313.345 197.284 315.542C196.621 317.735 196.142 319.306 195.854 320.236C193.675 327.134 191.492 334.019 189.304 340.879C197.221 341.739 205.161 342.384 213.113 342.812ZM316.437 374.165C294.029 378.38 271.289 380.798 248.501 381.417C248.495 377.216 248.49 373.015 248.486 368.814C263.087 347.481 277.759 325.223 292.333 302.489C278.176 304.263 263.934 305.355 249.673 305.764C249.678 300.413 249.684 295.062 249.691 289.711C271.672 289.086 293.607 286.851 315.26 283C315.23 287.172 315.205 291.344 315.184 295.515C300.703 318.996 286.118 342.017 271.612 364.127C286.611 362.924 301.548 360.942 316.343 358.182C316.367 363.511 316.399 368.838 316.437 374.165Z",
    fill: "white",
    fillOpacity: 0.9
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M106 145C122 190.5 361 186.5 368 145V206C337 167.5 274.697 187 237 213.5C186.5 249 105 247 106 211V145Z",
    fill: "url(#paint6_linear_103_70)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368 144.963V146H367.94C365.826 164.278 308.011 178.926 237 178.926C165.989 178.926 108.174 164.278 106.06 146H106V144.963V116H168.547C188.468 112.829 211.91 111 237 111C262.09 111 285.532 112.829 305.453 116H368V144.963Z",
    fill: "url(#paint7_linear_103_70)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237 153C322.604 153 392 130.614 392 103V70H353.449C325.043 59.5776 283.402 53 237 53C190.598 53 148.957 59.5776 120.551 70H82V103C82 130.614 151.396 153 237 153Z",
    fill: "url(#paint8_linear_103_70)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 237,
    cy: 70,
    rx: 155,
    ry: 50,
    fill: "#212121"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M184 23C199.155 21.2373 209.05 20.6037 229 20.06L328 110.5C309.838 114.67 299.383 116.361 280 118L184 23Z",
    fill: "#9C711E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M280 118C299.193 116.23 309.677 114.517 328 110.5V252.5C317 251 313.026 249.824 304 247.5C299.722 250.347 291.5 255 280 260V118Z",
    fill: "#CCA725"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M304.006 173.346C299.665 174.002 296.458 175.443 294.297 177.941C292.147 180.427 291.06 183.936 291.082 188.525C291.157 204.009 291.13 219.501 291 235C292.827 234.883 294.656 234.759 296.48 234.604C296.581 229.609 296.66 224.615 296.718 219.622C298.437 221.256 301.434 221.948 305.341 221.254C305.556 221.215 305.769 221.174 305.978 221.129V221.129C310.185 220.265 313.689 218 316.077 215.001C318.499 211.96 319.907 208.041 319.997 203.374C320.103 197.894 316.862 195.481 311.248 194.938C314.764 192.089 316.692 187.816 316.801 182.284C316.869 178.798 316.011 176.343 314.32 174.853C312.619 173.355 310.062 172.807 306.524 173.059C305.732 173.115 304.892 173.212 304.006 173.346V173.346ZM304.566 177.803C305.238 177.698 305.858 177.641 306.425 177.636C309.778 177.616 311.406 179.356 311.294 183.164C311.163 187.596 309.364 190.947 306.167 192.894C304.73 193.792 302.946 194.394 300.739 194.667C300.736 196.383 300.732 198.099 300.726 199.815C302.817 199.454 304.599 199.24 306.092 199.197C311.105 199.117 313.973 200.701 313.923 205.134C313.855 211.189 310.986 215.322 305.983 216.379C305.84 216.411 305.694 216.441 305.546 216.468C301.955 217.117 298.961 215.633 296.787 212.361C296.846 204.314 296.85 196.271 296.799 188.231C296.758 181.9 299.365 178.62 304.566 177.803V177.803Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_103_70",
    x1: 82,
    y1: 289,
    x2: 392,
    y2: 289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3B5BD",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.059645,
    stopColor: "#C3D7E0",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179573,
    stopColor: "#C3D7E0",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF5F9",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_103_70",
    x1: 106,
    y1: 308.929,
    x2: 367.004,
    y2: 308.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0797683,
    stopColor: "#016FBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117981,
    stopColor: "#017ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911119,
    stopColor: "#017ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#016FBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_103_70",
    x1: 237,
    y1: 184,
    x2: 237,
    y2: 275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003355"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_103_70",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(219 394.5) rotate(90) scale(31.5 113)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.631526,
    stopColor: "#016FBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885368,
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_103_70",
    x1: 106,
    y1: 207.244,
    x2: 368,
    y2: 207.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0207013,
    stopColor: "#016FBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.123105,
    stopColor: "#017ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#016FBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_103_70",
    x1: 302.504,
    y1: 184,
    x2: 302.504,
    y2: 234.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_103_70",
    x1: 106,
    y1: 192,
    x2: 368,
    y2: 192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0802511,
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.114554,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.900788,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917013,
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_103_70",
    x1: 106,
    y1: 229.548,
    x2: 367.004,
    y2: 229.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0797683,
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.119244,
    stopColor: "#343434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911119,
    stopColor: "#343434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_103_70",
    x1: 82,
    y1: 103,
    x2: 392,
    y2: 103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0782724,
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177817,
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909626,
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212121"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzle);
export default __webpack_public_path__ + "static/media/azle.5b68dfb8a190796cb9d50a7a5854b765.svg";
export { ForwardRef as ReactComponent };